import React, { useState } from 'react';
import { faqData } from '../data/mock';
import { ChevronDown } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 lg:py-32 bg-black relative overflow-hidden">
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        
        {/* Section Title */}
        <div className="text-center mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            {faqData.sectionTitle}
          </h2>
          <div className="w-20 h-1 bg-accent-red mx-auto"></div>
        </div>

        {/* FAQ Items */}
        <div className="max-w-4xl mx-auto space-y-4">
          {faqData.faqs.map((faq, index) => (
            <div 
              key={faq.id}
              className="bg-gradient-to-br from-gray-900/60 to-black/60 backdrop-blur-sm border border-gold/10 rounded-2xl overflow-hidden hover:border-gold/30 transition-all"
            >
              {/* Question */}
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-6 lg:p-8 text-left group"
              >
                <span className="text-lg lg:text-xl font-semibold text-white group-hover:text-gold transition-colors pr-4">
                  {faq.question}
                </span>
                <ChevronDown 
                  className={`text-gold flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`}
                  size={24}
                />
              </button>

              {/* Answer */}
              {openIndex === index && (
                <div className="px-6 lg:px-8 pb-6 lg:pb-8">
                  <div className="pt-4 border-t border-gold/10">
                    <p className="text-white/70 leading-relaxed text-base lg:text-lg">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
